export const getActiveFilterObject = (filtersSet, filterId) =>
  filtersSet.filter((obj) => obj.Id === filterId);

export const getActiveFilterLabel = (filterSetObj, selectedFilterId) =>
  filterSetObj.filter((obj) => obj.Id === selectedFilterId);

export const getIndexByFilterId = (eventFilters, filterId) =>
  eventFilters.findIndex((obj) => obj.FilterId === filterId);
